import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import AddHeader from '../components/AddHeader/AddHeader';
import FormContainer from '../components/FormContainer/FormContainer';
import { useNavigate } from 'react-router-dom';
import { addProduct, fetchProducts } from '../hooks/Products';
import { fetchCategories } from '../hooks/categories';
// import { addProduct, fetchProducts } from '../hooks/products';

function AddProduct() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const { list: categories } = useSelector((state) => state.categories);
  const categoriesOptions = categories.map((item) => ({
    value: item?.id, label: currentLocal.language === "العربيه" ? item?.name_ar : item?.name_en
  }))
  const [ar_productName, setar_productName] = useState('')
  const [en_productName, seten_productName] = useState('')
  const [price, setPrice] = useState('')
  const [catID, setcatID] = useState('')
  const [description_ar, setdescription_ar] = useState('')
  const [description_en, setdescription_en] = useState('')
  const [priceAfterDiscount, setpriceAfterDiscount] = useState('')
const [images, setImages] = useState([]);
const [imagePreviews, setImagePreviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sizes, setSizes] = useState([{ title: "", quantity: "" }]);
  const [colors, setColors] = useState([{ title: "", quantity: "" }]);
        const [attributes, setAttributes] = useState([
  { attribute_id: "", attribute_value_id: "" }
]);
const [variants, setVariants] = useState([
 { size_title:"", color_title:"", quantity:"" }
]);



const handleSizeChange = (index, field, value) => {
    const newSizes = [...sizes];
    newSizes[index][field] = value;
    setSizes(newSizes);
};
const addSizeRow = () => setSizes([...sizes, { title: "", quantity: "" }]);
const removeSizeRow = (index) => setSizes(sizes.filter((_, i) => i !== index));




const handleColorChange = (index, field, value) => {
    const newColors = [...colors];
    newColors[index][field] = value;
    setColors(newColors);
};
const addColorRow = () => setColors([...colors, { title: "", quantity: "" }]);
const removeColorRow = (index) => setColors(colors.filter((_, i) => i !== index));






const handleVariantChange = (index, field, value) => {
  const newVariants = [...variants];
  newVariants[index][field] = value;
  setVariants(newVariants);
};

const addVariantRow = () => {
  setVariants([...variants, { size: "", color: "", quantity: "" }]);
};

const removeVariantRow = (index) => {
  setVariants(variants.filter((_, i) => i !== index));
};

const handleAttributeChange = (index, field, value) => {
  const newAttributes = [...attributes];
  newAttributes[index][field] = value;
  setAttributes(newAttributes);
};

const addAttributeRow = () => {
  setAttributes([...attributes, { attribute_id: "", attribute_value_id: "", price_egp: "", price_sar: "" }]);
};

const removeAttributeRow = (index) => {
  setAttributes(attributes.filter((_, i) => i !== index));
};
      useEffect(() => {
            dispatch(fetchCategories());
      
      }, [dispatch])
const handleImageChange = (e) => {
  const files = Array.from(e.target.files);
  if (!files.length) return;

  setImages(prev => [...prev, ...files]);
  setImagePreviews(prev => [
    ...prev,
    ...files.map(file => URL.createObjectURL(file))
  ]);
};

  const inputs = [
    { id: 0, name: currentLocal.home.namePlaceholder + " " + currentLocal.home.inEN, value: en_productName, onChanegFunction: (e) => seten_productName(e.target.value), grid: 6 },
    // { id: 1, name: currentLocal.home.namePlaceholder + " " + currentLocal.home.inAR, value: ar_productName, onChanegFunction: (e) => setar_productName(e.target.value), grid: 6 },
    { id: 2, name: currentLocal.home.ProductCategory, value: catID, grid: 6, onChanegFunction: (selectedlecturer) => setcatID(selectedlecturer), type: "select", options: categoriesOptions },
    { id: 3, name: currentLocal.home.price, value: price, onChanegFunction: (e) => setPrice(e.target.value), grid: 6 },
    { id: 4, name: currentLocal.home.priceAfterDiscount, value: priceAfterDiscount, onChanegFunction: (e) => setpriceAfterDiscount(e.target.value), grid: 6 },
    { id: 5, name: currentLocal.home.description_en, value: description_en, onChanegFunction: (e) => setdescription_en(e.target.value), grid: 6 },
    // { id: 6, name: currentLocal.home.description_ar, value: description_ar, onChanegFunction: (e) => setdescription_ar(e.target.value), grid: 6 },
{
  id: 7,
  name: currentLocal.home.image,
  onChanegFunction: handleImageChange,
  grid: 6,
  type: "file",
  multiple: true,
  accept: "image/*"
}

  ]
  const handleSubmit = () => {
    const formData = new FormData();
// attributes.forEach((attr, index) => {
//     formData.append(`attributes[${index}][attribute_id]`, attr.attribute_id);
//     formData.append(`attributes[${index}][attribute_value_id]`, attr.attribute_value_id);
//     formData.append(`attributes[${index}][price_egp]`, 0);
//     formData.append(`attributes[${index}][price_sar]`, 0);
// });
    formData.append("category_id", catID?.value)
    formData.append("code", "PROD-0012340562")
    formData.append("description_ar", description_ar)
    formData.append("description_en", description_en)
    formData.append("price_egp", price)
    formData.append("price_sar", price)
    formData.append("discounted_price_egp", priceAfterDiscount)
    formData.append("name_ar", en_productName)
    formData.append("name_en", en_productName)

variants.forEach((item, index) => {
  formData.append(`variants[${index}][size]`, item.size);
  formData.append(`variants[${index}][color]`, item.color);
  formData.append(`variants[${index}][quantity]`, item.quantity);
});
images.forEach((img, index) => {
  formData.append("images[]", img); 
});

    setLoading(true)

    dispatch(addProduct(formData))
      .unwrap()
      .then(() => {
        setLoading(false)
        dispatch(fetchProducts())
        alert(currentLocal.home.addedsuccessfully)
        navigate("/dashboard/products")

      })
      .catch((err) => {
        setLoading(false)

      });
  }
const addAttribute = (
    <div className="attributes-section">
<h5 className="mb-3 border-bottom pb-2">{currentLocal.language=="English"?"Variants":"المتغيرات"}</h5>

{variants.map((item, index) => (
  <div key={index} className="row mb-3 align-items-end">

    <div className="col-md-3">
      <label>{currentLocal.home.Sizes}</label>
      <input
        type="text"
        className="form-control"
        value={item.size}
        onChange={(e) =>
          handleVariantChange(index, "size", e.target.value)
        }
      />
    </div>

    <div className="col-md-3">
      <label>{currentLocal.home.colors}</label>
      <input
        type="text"
        className="form-control"
        value={item.color}
        onChange={(e) =>
          handleVariantChange(index, "color", e.target.value)
        }
      />
    </div>

    <div className="col-md-3">
      <label>{currentLocal.home.Quantity}</label>
      <input
        type="number"
        className="form-control"
        value={item.quantity}
        onChange={(e) =>
          handleVariantChange(index, "quantity", e.target.value)
        }
      />
    </div>

    <div className="col-md-3">
      <button
        type="button"
        className="btn btn-danger w-100"
        onClick={() => removeVariantRow(index)}
      >
        {currentLocal.home.delete}
      </button>
    </div>

  </div>
))}

<button
  type="button"
  className="btn btn-secondary"
  onClick={addVariantRow}
>
  + Add Variant
</button>
    </div>
);
  return (
    <div className='outlit_bg'>
      <AddHeader
        title={currentLocal.home.addproduct}
      />
      <div className='body_container mx-4'  >
        <p className='border-bottom pb-3'>{currentLocal.home.addproduct}</p>
        <FormContainer
          inputs={inputs}
          btnText={currentLocal.home.add}
          handleSubmit={handleSubmit}
          loading={loading}
          imagePreview={imagePreviews}
          content={addAttribute}
        />
        {/* قسم السمات الديناميكي */}

      </div>
    </div>
  )
}

export default AddProduct


